import { connect } from 'react-redux'
import OnboardFinish from './components/Onboard/OnboardFinish'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ onboard: state.onboard }), mapDispatchToProps)(OnboardFinish)
